export default __webpack_public_path__ + "static/background-b046613ec9dc462323fe9534813a0af5.png";